import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { Action, Selector, State } from '@ngxs/store';
import { LoggedOutPageReady, LoginFailed, LoginSuccess, Logout, LogoutFailed, RequestLogin, RequestLogout, UpdateGeaIdUser, UpdateUser, UpdateUserName } from './user.actions';
import * as i0 from "@angular/core";
let UserState = class UserState {
  static userState(state) {
    return state;
  }
  static token(state) {
    return state.token;
  }
  static tokenObject(state) {
    if (!state.token) {
      return undefined;
    }
    const tokenDto = JSON.parse(atob(state.token.split('.')[1]));
    const token = {
      ...tokenDto,
      extension_admin_scopes: undefined,
      extension_truncated_admin_scopes: undefined
    };
    if (tokenDto.extension_admin_scopes) {
      token.extension_admin_scopes = JSON.parse(tokenDto.extension_admin_scopes);
    }
    return token;
  }
  static user(state) {
    return state.user;
  }
  static authState(state) {
    return state.state;
  }
  static expirationTime(state) {
    return state.tokenExpirationTime;
  }
  static loggedOutPageReady(state) {
    return state.loggedOutPageReady;
  }
  setLoginRequested({
    patchState
  }) {
    return patchState({
      state: "login requested" /* AuthState.LoginRequested */
    });
  }
  setLogoutRequested({
    patchState
  }) {
    return patchState({
      state: "logout requested" /* AuthState.LogoutRequested */
    });
  }
  setLoggedOutPageReady({
    patchState
  }) {
    return patchState({
      loggedOutPageReady: true
    });
  }
  setDataAfterLoginSuccess({
    patchState
  }, action) {
    return patchState({
      state: "logged in" /* AuthState.LoggedIn */,
      token: action.token,
      tokenExpirationTime: action.expirationTime
    });
  }
  setUserData({
    patchState
  }, action) {
    return patchState({
      state: "logged in" /* AuthState.LoggedIn */,
      user: {
        userId: action.userId,
        userName: action.userName,
        memberships: action.memberships
      }
    });
  }
  setGeaIdUserData({
    patchState,
    getState
  }, action) {
    return patchState({
      user: {
        ...getState().user,
        language: action.language,
        country: action.country,
        email: action.email,
        firstName: action.firstName,
        lastName: action.lastName,
        timeZone: action.timezone
      }
    });
  }
  setUserName({
    patchState,
    getState
  }, action) {
    return patchState({
      user: {
        ...getState().user,
        userName: action.userName
      }
    });
  }
  setLoginFailed({
    patchState
  }, action) {
    return patchState({
      state: "login failed" /* AuthState.LogInFailed */,
      loginError: action.error
    });
  }
  setLogoutFailed({
    patchState
  }) {
    return patchState({
      state: "logged in" /* AuthState.LoggedIn */
    });
  }
  setLogout({
    patchState
  }) {
    return patchState({
      state: "logout success" /* AuthState.LogoutSuccess */
    });
  }
  static ɵfac = function UserState_Factory(t) {
    return new (t || UserState)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserState,
    factory: UserState.ɵfac
  });
};
__decorate([Action(RequestLogin)], UserState.prototype, "setLoginRequested", null);
__decorate([Action(RequestLogout)], UserState.prototype, "setLogoutRequested", null);
__decorate([Action(LoggedOutPageReady)], UserState.prototype, "setLoggedOutPageReady", null);
__decorate([Action(LoginSuccess)], UserState.prototype, "setDataAfterLoginSuccess", null);
__decorate([Action(UpdateUser)], UserState.prototype, "setUserData", null);
__decorate([Action(UpdateGeaIdUser)], UserState.prototype, "setGeaIdUserData", null);
__decorate([Action(UpdateUserName)], UserState.prototype, "setUserName", null);
__decorate([Action(LoginFailed)], UserState.prototype, "setLoginFailed", null);
__decorate([Action(LogoutFailed)], UserState.prototype, "setLogoutFailed", null);
__decorate([Action(Logout)], UserState.prototype, "setLogout", null);
__decorate([Selector()], UserState, "userState", null);
__decorate([Selector()], UserState, "token", null);
__decorate([Selector()], UserState, "tokenObject", null);
__decorate([Selector()], UserState, "user", null);
__decorate([Selector()], UserState, "authState", null);
__decorate([Selector()], UserState, "expirationTime", null);
__decorate([Selector()], UserState, "loggedOutPageReady", null);
UserState = __decorate([State({
  name: 'userState',
  defaults: {
    state: "not set" /* AuthState.NotSet */,
    loggedOutPageReady: false,
    token: '',
    user: {
      userId: '',
      userName: '',
      country: '',
      memberships: []
    }
  }
})], UserState);
export { UserState };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserState, [{
    type: Injectable
  }], null, {
    setLoginRequested: [],
    setLogoutRequested: [],
    setLoggedOutPageReady: [],
    setDataAfterLoginSuccess: [],
    setUserData: [],
    setGeaIdUserData: [],
    setUserName: [],
    setLoginFailed: [],
    setLogoutFailed: [],
    setLogout: []
  });
})();
